"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemProvider = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _fp = require("lodash/fp");

var _theme = require("./theme");

var SystemProvider = function SystemProvider(_ref) {
  var themeOverrides = _ref.theme,
      props = (0, _objectWithoutProperties2.default)(_ref, ["theme"]);
  return _react.default.createElement(_styledComponents.ThemeProvider, (0, _extends2.default)({
    theme: (0, _fp.merge)(_theme.theme, themeOverrides)
  }, props));
};

exports.SystemProvider = SystemProvider;